export interface UpdateCollectionRequest {
  id: number
  collectionNo: string
  parentComposedCollectionId: number
  parentComposedCollectionNo: string
  status: string
  removeReason: string
  removeDate: string
  removeExpectedDate: string
  publishDate: string
  collectionType: string
  handlingType: string
  storeType: string
  appendixCode: string
  opacShow: boolean
  holdingBranchCode: string
  departmentCode: string
  forwardingBranchCode: string
  shelfType: string
  shelfTypeOld: string
  mark: string
  ndc: string
  book: string
  sub: string
  acceptDate: string
  acceptType: string
  acceptPrice: number
  listPrice: number
  applicantUserId: string
  traderCode: string
  donorCode: string
  budgetYear: number
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  workMemo: string
  displayMemo: string
  localMemo: string
  interlibraryLoanCode: string
  borrowingDate: string
  borrowingDueDate: string
  revision: number
  _isUpdateChildCollection: boolean
  icTagUid: string
  setNumber: number
}

export function UpdateCollectionRequestToJSON(
  value: UpdateCollectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    parent_composed_collection_id:
      value.parentComposedCollectionId !== 0
        ? value.parentComposedCollectionId
        : undefined,
    parent_composed_collection_no:
      value.parentComposedCollectionNo !== ''
        ? value.parentComposedCollectionNo
        : undefined,
    status: value.status !== '' ? value.status : undefined,
    remove_reason: value.removeReason !== '' ? value.removeReason : undefined,
    remove_date: value.removeDate !== '' ? value.removeDate : undefined,
    remove_expected_date:
      value.removeExpectedDate !== '' ? value.removeExpectedDate : undefined,
    publish_date: value.publishDate !== '' ? value.publishDate : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    store_type: value.storeType !== '' ? value.storeType : undefined,
    appendix_code: value.appendixCode !== '' ? value.appendixCode : undefined,
    opac_show: value.opacShow,
    holding_branch_code:
      value.holdingBranchCode !== '' ? value.holdingBranchCode : undefined,
    department_code:
      value.departmentCode !== '' ? value.departmentCode : undefined,
    forwarding_branch_code:
      value.forwardingBranchCode !== ''
        ? value.forwardingBranchCode
        : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    shelf_type_old: value.shelfTypeOld !== '' ? value.shelfTypeOld : undefined,
    mark: value.mark !== '' ? value.mark : undefined,
    ndc: value.ndc !== '' ? value.ndc : undefined,
    book: value.book !== '' ? value.book : undefined,
    sub: value.sub !== '' ? value.sub : undefined,
    accept_date: value.acceptDate !== '' ? value.acceptDate : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    accept_price: value.acceptPrice ? value.acceptPrice : undefined,
    list_price: value.listPrice ? value.listPrice : undefined,
    applicant_user_id:
      value.applicantUserId !== '' ? value.applicantUserId : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    work_memo: value.workMemo !== '' ? value.workMemo : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined,
    local_memo: value.localMemo !== '' ? value.localMemo : undefined,
    interlibrary_loan_code:
      value.interlibraryLoanCode !== ''
        ? value.interlibraryLoanCode
        : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_due_date:
      value.borrowingDueDate !== '' ? value.borrowingDueDate : undefined,
    revision: value.revision,
    _is_update_child_collection: value._isUpdateChildCollection ?? undefined,
    ic_tag_uid: value.icTagUid !== '' ? value.icTagUid : undefined,
    set_number: value.setNumber ? value.setNumber : undefined
  }
}
